// Hooks
import usePlatformURL from 'src/shared/domain/event/hook/usePlatformURL';

// Utils
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getTopicPermalink } from '@braindate/domain/lib/topic/util';

// Types
import type { Topic } from '@braindate/domain/lib/topic/type';

const useShareToLinkedIn = (topic?: Topic) => {
  const topicPermalink = !!topic && getTopicPermalink(topic);
  const platformURL = usePlatformURL();

  const shareToLinkedIn = () => {
    trackGAEvent('Topic details', 'Share on linkedIn');

    const url = topicPermalink
      ? `${topicPermalink}?utm_source=linkedIn`
      : `${platformURL}??utm_source=linkedIn`;

    window.open(
      `https://www.linkedin.com/shareArticle?url=${window.encodeURIComponent(
        url,
      )}&utm_source=braindate&utm_medium=linkedIn`,
      'newwindow',
      'width=500,height=400',
    );

    return false;
  };

  return shareToLinkedIn;
};

export default useShareToLinkedIn;
